import React from "react";
import {GlobalContext} from "../../GlobalContext";
import {Button, Col, Container, Row} from "react-bootstrap";
import {Glyph} from "../common/Glyph";

export default class AdminStatusPage extends React.Component {
    static contextType = GlobalContext;

    constructor(props) {
        super(props);
        this.state = {
            csvUploads: [],
            currentUsers: []
        }
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        this.context.apiRequest("GET", "/systemStatus")
            .then(d => {
                if (d && d.data) {
                    this.setState({...d.data});
                }
            })
    }

    render() {
        let uploads = this.state.csvUploads || [];
        let users = this.state.currentUsers || [];

        return <Container>
            <Row className={"mt-3"} sm={9}>
                <Col>
                    <b>Currently Logged In Users:</b>
                </Col>
                <Col className={"text-right"} sm={3}>
                    <Button onClick={this.loadData} variant={"secondary"}><Glyph name={"arrow-clockwise"}/></Button>
                </Col>
            </Row>
            <Row>
                <Col>
                    {
                        users.length == 0 && <>None</>
                    }
                    {
                        users.length > 0 && <ul>
                            {
                                users.map((u,i) => <li key={u.username}>{u.username}</li>)
                            }
                        </ul>
                    }
                </Col>
            </Row>
            <Row>
                <Col>
                    <b>Current CSV File Uploads:</b>
                </Col>
            </Row>
            <Row>
                <Col>
                    {
                        uploads.length == 0 && <>None</>
                    }
                    {
                        uploads.length > 0 && <ul>
                            {
                                uploads.map((u,i) => <li key={i}>{u.fileName} ({u.progress}%)</li>)
                            }
                        </ul>
                    }
                </Col>
            </Row>
        </Container>
    }
}